export enum OfferStatus {
  AVAILABLE = 'AVAILABLE',
  TAKEN = 'TAKEN',
}

export interface Offer {
  offer_reference?: string;
  offerReference?: string;
  offer_status?: OfferStatus;
  expected_delivery_date?: unknown;
  number_of_replacements?: number;
  number_of_upgrades?: number;
  upsell_flag?: boolean;
  upsell_reason?: string;
  rrp_flag?: boolean;
  outstanding_dd_amount?: number;
  outstanding_dd_count?: number;
}

export const Offer = undefined;
